export default function () {


    $(() => {
        const submitButton = $('#btn-submit', 'form');
        submitButton.on('click', (e) => {
            const token = $('input[name="cf-turnstile-response"]').val();
            if (!token) {
                e.preventDefault();
            }
        });
    });
}
